import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import './SuccessComponent.scss';
function SuccessComponent() {
    const history = useHistory();
    const location = useLocation();
    const { userID, token, clientId } = location.state || {};
    
    const handleClick = () => {
        const queryParams = new URLSearchParams({
            userID: userID,
            token: token,
            clientId: clientId,
        }).toString();

        history.push(`/preference?${queryParams}`);
    }

    return (
        <div className="message-confirmation">
            <div className="success-message">
                <img src={`${process.env.PUBLIC_URL}/images/success.svg`} alt='Success'/>
                <h2>Updated Successfully!</h2>
                <p>Your changes have been saved successfully.</p>

                <button onClick={handleClick}>Go Back</button>
            </div>
        </div>
    );
}

export default SuccessComponent;
